import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import { fullName } from "../../constants/sorters";

const mapBonitaet = (kunde) => {
  const v = Number(kunde?.bonitaet_status ?? 1);
  if (v === 3) return { short: "Rot", color: "bg-red-500/15 text-red-200 border-red-400/40" };
  if (v === 2) return { short: "Gelb", color: "bg-amber-500/15 text-amber-200 border-amber-400/40" };
  return { short: "Grün", color: "bg-green-500/15 text-green-200 border-green-400/40" };
};

function KundeCard({ kunde }) {
  const navigate = useNavigate();
  const firma = kunde?.firma?.trim() || "";
  const person = fullName(kunde);
  const title = firma || person || `Kunde #${kunde.id}`;
  const addr = [kunde?.strasse, [kunde?.plz, kunde?.ort].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const line2 = firma && person ? person : addr || "Adresse unbekannt";
  const boni = mapBonitaet(kunde);

  const open = () => navigate(`/kunden/${kunde.id}`);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open();
        }
      }}
      aria-label={`Kunde öffnen: ${title}`}
      className="group interactive-card cursor-pointer text-left rounded-2xl px-4 py-3 border transition-all focus:outline-none focus-within:ring-2 bg-surface border-default hover:!bg-surface focus-within:ring-blue-400/30"
    >
      <div className="flex items-start justify-between gap-2 min-w-0">
        <div className="min-w-0 flex-1">
          <div className="text-[15px] font-semibold text-blue-100/90 truncate" title={title}>
            {title}
          </div>
          <div className="text-[12px] text-blue-200/70 truncate mt-0.5" title={line2}>
            {line2}
          </div>
        </div>
        <span
          className={`shrink-0 inline-flex items-center px-1.5 py-0.5 rounded-full border text-[10px] font-medium leading-none ${boni.color}`}
          title={`Bonität ${boni.short}`}
        >
          {boni.short}
        </span>
      </div>
    </div>
  );
}

export default memo(KundeCard);
